import { useContext } from 'react';
import { GearIcon } from 'assets/icons';
import { useSession } from 'contexts';
import { useQuery } from '@apollo/client';
import { GetOrganizationSettingsDocument, GetUserInfoDocument} from 'graphql/generated';
import NotificationsSettings from './Partials/NotificationsSettings';
import Toast, { useToast } from 'components/Toast/Toast';
import UserDocuments from './Partials/UserDocuments';
import OrganizationDocuments from './Partials/OrganizationDocuments';
import Tabs from 'components/Tabs/Tabs';
import IntergationsSettings from './Partials/IntergationsSettings';
import OrganizationSettings from './Partials/OrganizationSettings';
import UsersSettings from './Partials/UsersSettings';
import BillingSettings from './Partials/BillingSettings';
import { AbilityContext } from 'contexts/AbilityContext';
import useParamState from 'hooks/useParamState';
import isMobileApp from 'utils/isMobileApp';
import { doesContatinSubjects } from 'utils/PermissionHandler';
import ProfileSettings from './Partials/ProfileSettings';
import Header from 'components/Header/Header';

const Settings = function () {
  const ability = useContext(AbilityContext);
  const { organizationId } = useSession();
  const { toastProps } = useToast();
  const [activeTab, setActiveTab] = useParamState('settingsTab', 'Profile');
  
  
  const tabs = ['Profile', 'Notifications', 
  ...(doesContatinSubjects({ action:'PART91', subjects:['Admin'], ability}) ? ['Organization'] : []),
  ...(doesContatinSubjects({ action:'PART91', subjects:['Admin'], ability}) && !isMobileApp() ? ['Billing'] : []),
  , 'Users',  'Integrations', 'Organization Documents', 'Personal Documents' ];
  const { data: { me } = { } } = useQuery(GetUserInfoDocument, { fetchPolicy: 'network-only' });
  const { data: { organization } = {}, refetch } = useQuery(GetOrganizationSettingsDocument, { variables: { id: organizationId }  }); 

  return (
    <>
      {/* HEADER */}
      <Header title="Settings" icon={GearIcon} className="border-b-0 rounded-b-none" />
      <div className="flex items-start bg-slate-50 rounded-b border border-slate-300 -mt-2 mb-2">
        <Tabs items={tabs} activeItem={activeTab} setActiveItem={setActiveTab} className="px-6"/>
      </div>
      {/* PROFILE */}
      { activeTab === 'Profile' && <ProfileSettings />}
      {/* NOTIFICATIONS */}
      { activeTab === 'Notifications' && <NotificationsSettings settings={me?.selectedOrganizationProfile?.notificationSettings} id={me?.selectedOrganizationProfile?.id}/> }
      {/* ORGANIZATION */}
      { activeTab === 'Organization' && <OrganizationSettings organization={organization} /> }
      {/* BILLING */}
      { activeTab === 'Billing' && <BillingSettings organization={organization} organizationRefetch={refetch} /> }
      {/* USERS */}
      { activeTab === 'Users' && <UsersSettings /> }
      {/* INTEGRATIONS DOCUMENTS */}
      { activeTab === 'Integrations' && <IntergationsSettings organization={organization} /> }
      {/* ORGANIZATION DOCUMENTS */}
      { activeTab === 'Organization Documents' && <OrganizationDocuments /> }
      {/* USER DOCUMENTS */}
      { activeTab === 'Personal Documents' && <UserDocuments/> }
    </>
  );
};

export default Settings;
